import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ColorSwatchPicker from '../../../components/ColorSwatchPicker';
import { hideModal } from '../../../redux/actions/modal';
import text from '../../../text';
export const COLOR_SWATCH_MODAL = 'COLOR_SWATCH_MODAL';

const ColorSwatchModal: React.FC<{
  show: boolean;
  initialHex: string;
  onApply: (hex: string) => void;
}> = ({ show, initialHex, onApply }) => {
  const dispatch = useDispatch();
  const [pendingHex, setPendingHex] = useState(initialHex);

  const handleHide = useCallback(
    () => dispatch(hideModal(COLOR_SWATCH_MODAL)),
    [dispatch]
  );

  useEffect(() => {
    if (show) {
      setPendingHex(initialHex);
    }
  }, [show, initialHex]);

  return (
    <Modal
      centered
      show={show}
      onHide={handleHide}
      className='ColorSwatchModal'
    >
      <Modal.Header className='d-flex flex-row justify-content-center mb-4'>
        <h3>{text('pickACustomColor')}</h3>
      </Modal.Header>
      <Modal.Body className='p-0 bg-white'>
        <ColorSwatchPicker
          value={pendingHex}
          onChange={(hex) => setPendingHex(hex)}
          containerClassName='p-0'
        />
      </Modal.Body>
      <Modal.Footer className='d-flex flex-row flex-gap-8 justify-content-between px-0 pb-0 mt-3'>
        <Button
          variant='outline-primary'
          onClick={handleHide}
          className='d-flex flex-fill'
        >
          {text('close')}
        </Button>
        <Button
          variant='primary'
          onClick={() => {
            onApply(pendingHex);
            handleHide();
          }}
          className='d-flex flex-fill'
        >
          {text('done')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ColorSwatchModal;
